import { Component, ChangeDetectionStrategy, Inject, Optional } from '@angular/core';

import { SnCamera } from '@lib/api/entities';
import { GOOGLE_MAP_POPUP_DATA } from '@lib/geo/google/map';
import { MAP_POPUP_DATA } from '@lib/geo/map';

@Component({
  selector: 'sn-camera-view-popup',
  templateUrl: './camera-view-popup.component.html',
  styleUrls: ['./camera-view-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CameraViewPopupComponent {
  public autoplay: boolean = true;
  public camera: SnCamera;

  constructor(
    // Currently need both to prevent errors between the FsMap and GoogleMap components.
    @Optional() @Inject(GOOGLE_MAP_POPUP_DATA) private readonly googleMapCamera: SnCamera | null,
    @Optional() @Inject(MAP_POPUP_DATA) private readonly mapCamera: any | null,
  ) {
    this.camera = this.googleMapCamera || this.mapCamera.data || undefined;
  }
}
